import _ from 'lodash'

export const getItems = (state, props) => _.get(state, 'itemActions.allItems.data')



// WEBPACK FOOTER //
// ./src/selectors/items.js